// extracted by mini-css-extract-plugin
export default {"tag":"Tags_tag__TJsxE","root":"Tags_root__o8keU","active":"Tags_active__ILB74"};